import { render, staticRenderFns } from "./CodeWords.vue?vue&type=template&id=2d9cb5c7"
import script from "./CodeWords.vue?vue&type=script&lang=js"
export * from "./CodeWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports